const ModalRemote = () => {
    "use strict";
    /**
     * Brings back remote content data fetch option in Bootstrap v4
     * example: <a href="#" data-bs-toggle="modal" data-remote="remote.html" data-target="#modal">Click me</a>
     *
     * @param $selector
     *
     * @see LPUPCMS-376
     * @see https://getbootstrap.com/docs/3.4/javascript/#modals-options
     */
    const init = function ($selector) {
        if (!$selector) {
            $selector = $(document);
        } else if (!($selector instanceof $)) {
            $selector = $($selector);
        }
        $selector.off('click.modal.data-api', '[data-bs-toggle="modal"][data-setu-remote]');
        $selector.on('click.modal.data-api', '[data-bs-toggle="modal"][data-setu-remote]', event => {
            const $modalTrigger = $(event.currentTarget);
            $($modalTrigger.data('bs-target') + ' .modal-content').load($modalTrigger.data('setu-remote'));
        });
    };
    return {
        init,
    };
};
export const modalRemote = ModalRemote();
